import axios from 'axios';

const API_URL = process.env.REACT_APP_API_SERVER_ENDPOINT;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Get current instance configuration
export const getInstanceConfig = () => api.get('/instance/config');

// Save instance configuration
export const saveInstanceConfig = (memberId) =>
  api.post('/instance/config', { memberId });

// Get available members for selection
export const getAvailableMembers = () => api.get('/instance/available-members');

// Reset instance configuration
export const resetInstanceConfig = () => api.delete('/instance/config');
